import { Navbar } from './app-navbar';

export const NAVBARS: Navbar[] = [
    { id: 1, name: '首页', route: '/hmpg' },
    /*{ id: 5, name: '合肥禅生' , route: '/about'},*/
    { id: 4, name: '消费类产品' , route: '/jcal'},
    /*{ id: 2, name: '消费类产品', route: '/zyly' },*/
    { id: 3, name: '通信类产品' , route: '/zytd'},    
   /* { id: 7, name: '动态新闻' , route: '/dtzx'},*/
    { id: 8, name: 'MCU类产品' , route: '/yjzx'},
    { id: 6, name: '联系我们' , route: '/contact'}
  ];

export const NAVBARS_EN: Navbar[] = [
  /*{ id: 1, name: 'HOMPAGE', route: '/en-hmpg' },
  { id: 5, name: 'ABOUT' , route: '/en-abouten' },
  { id: 2, name: 'PROFESSIONAL FIELD', route: '/en-zyly' },
  { id: 3, name: 'TEAM' , route: '/en-zytd'},
  { id: 4, name: 'CASE' , route: '/en-jcalen' },
  { id: 6, name: 'CONTACT' , route: '/en-contacten'}*/
];
